// import React, { useState, useRef } from "react";
// import { getLeaveDetailsForEmp } from "../../api/leavesApi"; // your API import

// export default function LeaveDetails() {
//   const employeeCode = sessionStorage.getItem("username");

//   const [filters, setFilters] = useState({ year: "", month: "" });
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const formRef = useRef(null);

//   const fetchLeaves = async (e) => {
//     e.preventDefault();

//     if (!filters.year) {
//       setError("Please enter the year");
//       return;
//     }

//     setLoading(true);
//     setError("");
//     try {
//       const data = await getLeaveDetailsForEmp(employeeCode, filters.year, filters.month || null);
//       setLeaves(data || []);
//     } catch (err) {
//       setError("Failed to load leave details");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClear = () => {
//     setFilters({ year: "", month: "" });
//     setLeaves([]);
//     setError("");
//   };

//   return (
//     <div className="container-fluid p-3">
//       <h4 className="mb-3">Leave Details</h4>

//       <form ref={formRef} className="row g-3 mb-4" onSubmit={fetchLeaves}>
//         <div className="col-md-3">
//           <label className="form-label">Year <span className="text-danger">*</span></label>
//           <input
//             type="number"
//             className="form-control"
//             min="2000"
//             max="2100"
//             placeholder="Enter year"
//             value={filters.year}
//             onChange={(e) => setFilters({ ...filters, year: e.target.value })}
//             required
//           />
//         </div>

//         <div className="col-md-3">
//           <label className="form-label">Month</label>
//           <input
//             type="number"
//             className="form-control"
//             min="1"
//             max="12"
//             placeholder="Enter month (optional)"
//             value={filters.month}
//             onChange={(e) => setFilters({ ...filters, month: e.target.value })}
//           />
//         </div>

//         <div className="col-md-3 d-flex align-items-end gap-2">
//           <button type="submit" className="btn btn-primary">
//             Fetch
//           </button>
//           <button type="button" className="btn btn-secondary" onClick={handleClear}>
//             Clear
//           </button>
//         </div>
//       </form>

//       {loading && <p>Loading leave details...</p>}
//       {error && <p className="text-danger">{error}</p>}

//       {!loading && leaves.length > 0 && (
//     <div className="allowance-table-container">
//       <table className="allowance-table">
//             <thead className="table-primary">
//               <tr>
//                 <th>Leave Name</th>
//                 <th>Last Year Balance</th>
//                 <th>Credited</th>
//                 <th>Availed</th>
//                 <th>Closing Balance</th>
//               </tr>
//             </thead>
//             <tbody>
//               {leaves.map((leave) => (
//                 <tr key={leave.leaveName}>
//                   <td>{leave.leaveName}</td>
//                   <td>{leave.lastYearBalance}</td>
//                   <td>{leave.credited}</td>
//                   <td>{leave.availed}</td>
//                   <td>{leave.closingBalance}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {!loading && !error && leaves.length === 0 && (
//         <p>No leave details found for the selected filters.</p>
//       )}
//     </div>
//   );
// }





import React, { useState, useEffect } from "react";
import { getLeaveDetailsForEmp } from "../../api/leavesApi";

export default function LeaveDetails() {
  const employeeCode = sessionStorage.getItem("username") || "AIM000001";

  const [filters, setFilters] = useState({
    year: new Date().getFullYear(),      // auto-set current year
    month: "",                           // month optional
  });
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Auto-fetch when component mounts
  useEffect(() => {
    fetchLeaves(); // fetch immediately with default year
  }, []);

  const fetchLeaves = async () => {
    if (!filters.year) {
      setError("Please enter the year");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const data = await getLeaveDetailsForEmp(
        employeeCode,
        filters.year,
        filters.month || null
      );
      setLeaves(data || []);
    } catch (err) {
      console.error("API error:", err);
      setError("Failed to load leave details");
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFilters({ year: "", month: "" });
    setLeaves([]);
    setError("");
  };

  return (
    <div className="container-fluid p-3">
      <h4 className="mb-3">Leave Details</h4>

      <form className="row g-3 mb-4" onSubmit={(e) => {
        e.preventDefault();
        fetchLeaves();
      }}>
        <div className="col-md-3">
          <label className="form-label">Year <span className="text-danger">*</span></label>
          <input
            type="number"
            className="form-control"
            min="2000"
            max="2100"
            placeholder="Enter year"
            value={filters.year}
            onChange={(e) => setFilters({ ...filters, year: e.target.value })}
            required
          />
        </div>

        <div className="col-md-3">
          <label className="form-label">Month (See only Availed leaves)</label>
          <input
            type="number"
            className="form-control"
            min="1"
            max="12"
            placeholder="Enter month (optional)"
            value={filters.month}
            onChange={(e) => setFilters({ ...filters, month: e.target.value })}
          />
        </div>

        <div className="col-md-3 d-flex align-items-end gap-2">
          <button type="submit" className="btn btn-primary btn-sm">Show</button>
          <button type="button" className="btn btn-secondary btn-sm" onClick={handleClear}>Clear</button>
        </div>
      </form>

      {loading && <p>Loading leave details...</p>}
      {error && <p className="text-danger">{error}</p>}

      {!loading && leaves.length > 0 && (
        // <div className="table-responsive">
        //   <table className="table table-bordered table-hover">
        <div className="allowance-table-container">
         <table className="allowance-table">
            <thead className="table-primary">
              <tr>
                <th>Leave Name</th>
                <th>Last Year Balance</th>
                <th>Credited</th>
                <th>Availed</th>
                <th>Closing Balance</th>
              </tr>
            </thead>
            <tbody>
              {leaves.map((leave) => (
                <tr key={leave.leaveName}>
                  <td>{leave.leaveName}</td>
                  <td>{leave.lastYearBalance}</td>
                  <td>{leave.credited}</td>
                  <td>{leave.availed}</td>
                  <td>{leave.closingBalance}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && !error && leaves.length === 0 && (
        <p>No leave details found for the selected filters.</p>
      )}
    </div>
  );
}
